import { CardContent, CardActions } from '@mui/material';
import List from '@mui/material/List';
import React from 'react';
import useWebContext from '../../hooks/useWebContext';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { HomeFileListItem, HomeLeftHeader, HomeNoContentBox } from './HomeUtils';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

export const HomeWhatNewCard = ({ screenId, boxFile, onPreview }) => {
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  // 2026.2.25 タブレット表示時対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2026.2.25 タブレット表示時対応 Add End

  // 2026.2.25 タブレット表示時対応 Modify Start
  return (
    <OutlinedCustomCard sx={{ display: 'flex', flexDirection: 'column', height: '369px', overflowY: isPc ? 'visible' : 'auto' }}>
      <HomeLeftHeader title={controlSettings.LabelList.WhatsNewTitle} sx={{ fontWeight: "bolder", paddingTop: "8px" }} />
      <CardContent sx={{
        flex: 1,
        height: '90%',
        "&:last-child": {
          paddingBottom: "0px",
          paddingTop: "0px",
          paddingLeft: "2px"
        }
      }} >
        {boxFile.length > 0 ?
          <List>
            {boxFile.map((item) => {
              return (
                <HomeFileListItem
                  screenId={screenId}
                  fileId={item.FileId}
                  uploadDate={item.UploadDate}
                  fileName={item.NameDisp}
                  fileNameAbbMaxLength={screenSettings.LatestBoxFileNameMaxLength}
                  extension={item.Extension}
                  onPreview={onPreview}
                  key={item.FileId} />
              )
            })}
          </List>
          :
          <HomeNoContentBox content={messageList.MyM_MSG_I_0059} />
        }
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
        <CardActions sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
          <NavigateLink
            to={'/MyM102/MyM401'}
            underline="hover"
            sx={{ color: "#60AEE1" }}
            navigateState={{
            state:
            {
              searchValue: '',
              isLoadSearchKeyword: true,
              isAdvancedSearch: false
            }
          }} >
            {controlSettings.LabelList.lnkSeeAllWhatsNew}
          </NavigateLink>
        </CardActions >
        {/*2025.7.7 MyMine Version3.0対応 Add End*/}
      </CardContent>
    </OutlinedCustomCard>
  )
  // 2026.2.25 タブレット表示時対応 Modify End
}
